import React, { useEffect, useMemo, useState } from 'react';
import comedora from '../img/comedora.png';
import granada from '../img/granada.png';
import guasasapotv from '../img/gtv.png';
import trincheta from '../img/trincheta.png';
import selloNuevo from '../assets/guasasapo-sello-redondo-final.png';

const START_DATE = new Date(2023, 11, 30, 20, 55, 0);

function calculateElapsedParts(fromDate, toDate) {
  const start = new Date(fromDate);
  const end = new Date(toDate);

  if (end <= start) {
    return {
      years: 0,
      months: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
    };
  }

  let cursor = new Date(start);
  let years = end.getFullYear() - cursor.getFullYear();
  cursor.setFullYear(cursor.getFullYear() + years);
  if (cursor > end) {
    years -= 1;
    cursor.setFullYear(cursor.getFullYear() - 1);
  }

  let months = 0;
  while (true) {
    const next = new Date(cursor);
    next.setMonth(next.getMonth() + 1);
    if (next <= end) {
      months += 1;
      cursor = next;
    } else {
      break;
    }
  }

  let diffMs = end.getTime() - cursor.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  diffMs -= days * 1000 * 60 * 60 * 24;
  const hours = Math.floor(diffMs / (1000 * 60 * 60));
  diffMs -= hours * 1000 * 60 * 60;
  const minutes = Math.floor(diffMs / (1000 * 60));
  diffMs -= minutes * 1000 * 60;
  const seconds = Math.floor(diffMs / 1000);

  return { years, months, days, hours, minutes, seconds };
}

const Hibernacion = ({ homeMode = false }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => {
      setNow(new Date());
    }, 1000);

    return () => window.clearInterval(interval);
  }, []);

  const elapsed = useMemo(() => calculateElapsedParts(START_DATE, now), [now]);

  const items = [
    { label: 'años', shortLabel: 'AÑOS', value: elapsed.years },
    { label: 'meses', shortLabel: 'MESES', value: elapsed.months },
    { label: 'días', shortLabel: 'DÍAS', value: elapsed.days },
    { label: 'horas', shortLabel: 'HORAS', value: elapsed.hours },
    { label: 'minutos', shortLabel: 'MINUTOS', value: elapsed.minutes },
    { label: 'segundos', shortLabel: 'SEGUNDOS', value: elapsed.seconds },
  ];

  const hoverMarks = homeMode
    ? [
        { href: '/comedora', src: comedora, alt: 'Comedora Vegana y Guasasapo', className: 'hover-comedora' },
        { href: '/trincheta', src: trincheta, alt: 'Trincheta', className: 'hover-trincheta' },
        { href: '/granada', src: granada, alt: 'Granada', className: 'hover-granada' },
        { href: '/guasasapotv', src: guasasapotv, alt: 'Guasasapo TV', className: 'hover-tv', clickable: true },
      ]
    : [
        { href: '/comedora', src: comedora, alt: 'Comedora Vegana y Guasasapo', className: 'hover-comedora', clickable: true },
        { href: '/trincheta', src: trincheta, alt: 'Trincheta', className: 'hover-trincheta', clickable: true },
        { href: '/granada', src: granada, alt: 'Granada', className: 'hover-granada', clickable: true },
        { href: '/guasasapotv', src: guasasapotv, alt: 'Guasasapo TV', className: 'hover-tv', clickable: true },
      ];

  return (
    <main className="hibernation">
      <div className="hibernation__glow hibernation__glow--left" />
      <div className="hibernation__glow hibernation__glow--right" />

      <section className="hibernation__content">
        <h1 className="hibernation__title">Periodo de Hibernación</h1>

        <div className="hibernation__sealGroup">
          <div className={`hibernation__seal${homeMode ? ' hibernation__seal--static' : ''}`} aria-label="Sello Guasasapo">
            <img src={selloNuevo} alt="Sello circular Guasasapo" />
          </div>

          {!homeMode ? (
            <a className="hibernation__sealRestLink" href="/guasasapo" aria-label="Ir a Guasasapo" tabIndex="-1">
              <span className="hibernation__sealRestHitbox" aria-hidden="true" />
            </a>
          ) : null}

          <div className="hibernation__hoverMarks" aria-hidden="true">
            {hoverMarks.map((mark) => {
              const className = `hibernation__hoverMark ${mark.className}`;
              return mark.clickable ? (
                <a className={className} href={mark.href} key={mark.href} tabIndex="-1">
                  <img src={mark.src} alt={mark.alt} />
                </a>
              ) : (
                <div className={className} key={mark.href}>
                  <img src={mark.src} alt={mark.alt} />
                </div>
              );
            })}
          </div>
        </div>

        <div className="hibernation__timer" aria-live="polite">
          <div className="hibernation__timerGrid">
            {items.map((item) => (
              <div className="hibernation__unit" key={item.label}>
                <span className="hibernation__value">{String(item.value).padStart(2, '0')}</span>
                <span className="hibernation__label">{item.shortLabel}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Hibernacion;
